import { HttpHeaders } from '@angular/common/http';
import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { ConfirmationService, MessageService, TreeNode, Message } from 'primeng/api';
import { FileUpload } from 'primeng/fileupload';
import { BreadcrumbService } from 'src/app/app.breadcrumb.service';
import { JwtService, User, UserService } from 'src/app/core';
import { FAZILService } from 'src/app/core/services/fazil.service';
import { UIService } from 'src/app/core/services/ui.service';
import { EliminarData } from 'src/app/modelo/EliminarData';
import { Reporte } from 'src/app/modelo/Reporte';
import { TareaModel } from 'src/app/modelo/Tarea.model';
import { UsuarioModel } from 'src/app/modelo/usuario.model';
import { environment } from 'src/environments/environment';
import { AdministracionService } from '../administracion.service';

@Component({
    selector: 'app-admin-reportes',
    templateUrl: './admin-reportes.component.html',
    styleUrls: ['./admin-reportes.component.scss']
})
export class AdminReportesComponent implements OnInit {

    //Variables de configuración/mensajes
    appConfig = environment.settings;
    errors: Object = {};
    msgs: Message[] = [];

    //Variables con objeto de edición
    currentUser: User;
    reportes: Reporte[] = [];
    reportesSeleccionados: Reporte[] = [];
    reporte: Reporte = new Reporte();
    eliminarData: EliminarData;

    //Catálogos
    catalogoModulosArbolSimple: TreeNode[] = [];
    catalogoModulosArbolSimpleNodoSeleccionado: TreeNode;

    //Variables auxiliares
    clasesReporte = [
        { name: 'Individual', code: 'individual' },
        { name: 'Lista', code: 'lista' },
    ];
    motoresReporte = [
        { name: 'Jasper', code: 'jasper' },
    ];
    claseReporte: any;
    motorReporte: any;
    mostrarEditor: boolean = false;
    mostrarEditorModulo: boolean = false;
    cols: any[];
    multiSortMeta = [];
    cargandoDataInit: boolean = false;
    procesando: boolean = false;
    ui: UIService;

    //Carga de archivos
    uploadServiceURL: string = "";
    httpHeaders: HttpHeaders;
    cargarArchivosForm: FormGroup;
    mostrarVentanaCargaArchivos: boolean = false;
    isSubmitting = false;
    file_error = false;
    @ViewChild('fileInput') fileInput: FileUpload;
    @ViewChild('dt') dt: any;

    constructor(
        private router: Router,
        private userService: UserService,
        private fazilService: FAZILService,
        private uiService: UIService,
        private administracionService: AdministracionService,
        private confirmationService: ConfirmationService,
        private breadcrumbService: BreadcrumbService,
        private messageService: MessageService,
        private fb: FormBuilder,
        private jwtService: JwtService,
    ) {
        this.ui = uiService;
        this.cargarDataConstructor();
    }

    cargarDataConstructor() {
        this.cargandoDataInit = true;
        this.breadcrumbService.setItems([
            { label: 'Administración de Reportes', routerLink: ['administracion/reportes'] }
        ]);
        this.uploadServiceURL = this.appConfig.apiServer + "/documentos/cargar";
        this.cargarArchivosForm = this.fb.group({
        });
        const token = this.jwtService.getToken();
        this.httpHeaders = new HttpHeaders();
        this.httpHeaders.append('Authorization', `Bearer ${token}`);
        this.httpHeaders.append('Content-Type', `multipart/form-data`);
        this.cols = [
            { field: 'name', header: 'Nombre', visible: true },
            { field: 'tipo', header: 'Módulo', visible: true },
            { field: 'clase', header: 'Clase', visible: true },
            { field: 'motor', header: 'Motor', visible: true },
            { field: 'url', header: 'Archivo', visible: false },
            //            { field: 'parametros', header: 'Parámetros', visible: false },
            //            { field: 'descripcion', header: 'Descripción', visible: false },
            //            { field: 'id', header: 'Id', visible: false },
        ];
        this.multiSortMeta.push({ field: 'nombre', order: 1 });
    }

    ngOnInit(): void {
        this.userService.currentUser.subscribe(userData => {
            this.currentUser = userData;
            if (this.currentUser && this.currentUser.uuid) {
                this.cargarDataInit();
            }
        });
    }

    async cargarDataInit() {
        this.catalogoModulosArbolSimple = await this.administracionService.getTareasArbolSimpleData();
        this.reportes = await this.administracionService.getReportesActivosData();
        this.cargandoDataInit = false;
    }

    resetVariables(): void {
        this.ui.limpiarMessages();
        this.mostrarEditor = false;
        this.mostrarEditorModulo = false;
        this.mostrarVentanaCargaArchivos = false;
        this.catalogoModulosArbolSimpleNodoSeleccionado = null;
        this.claseReporte = null;
        this.motorReporte = null;
        this.reporte = new Reporte();
    }

    nuevoReporte(): void {
        this.resetVariables();
        this.motorReporte = (this.motoresReporte && this.motoresReporte.length > 0) ? this.motoresReporte[0] : null;
        this.mostrarEditor = true;
    }

    editarReporte(reporte: Reporte): void {
        this.resetVariables();
        this.administracionService.getReporte(reporte.uuid).subscribe(data => {
            this.reporte = data;
            if (this.reporte.tipo) {
                this.catalogoModulosArbolSimple.forEach((node) => {
                    this.findNodeRecursive(node, this.reporte.tipo);
                });
            }
            if (this.reporte.clase) {
                this.claseReporte = this.clasesReporte.find((item) => item.code == this.reporte.clase) ? this.clasesReporte.find((item) => item.code == this.reporte.clase) : null;
            }
            if (this.reporte.motor) {
                this.motorReporte = this.motoresReporte.find((item) => item.code == this.reporte.motor) ? this.motoresReporte.find((item) => item.code == this.reporte.motor) : null;
            }
            this.mostrarEditor = true;
        });
    }

    formPrincipalCompleto() {
        return this.catalogoModulosArbolSimpleNodoSeleccionado && this.claseReporte && this.motorReporte;
    }

    guardarReporte(): void {
        this.ui.limpiarMessages();
        if (!this.formPrincipalCompleto()) {
            this.ui.mostrarMensaje("error", `${this.appConfig.ux.formIvalid}`);
        } else {
            //Establecer valores UX
            this.reporte.tipo = this.catalogoModulosArbolSimpleNodoSeleccionado['data']['routerLink'];
            this.reporte.clase = this.claseReporte.code;
            this.reporte.motor = this.motorReporte.code;
            this.administracionService.guardarReporte(this.reporte).subscribe(
                async (data) => {
                    this.reporte = data;
                    this.reportes = await this.administracionService.getReportesActivosData();
                    this.ui.mostrarMensaje("success", `Actualización del reporte ${this.reporte.name} se realizó con éxito.`);
                    this.mostrarEditor = false;
                },
                (err) => {
                    this.ui.mostrarError(err);
                }
            );
        }
    }

    confirmarBorrarReporte(reporte: Reporte): void {
        this.resetVariables();
        this.confirmationService.confirm({
            message: "¿Está seguro de eliminar el reporte <strong>" + reporte.name + "</strong>?. No será posible recuperar la información.",
            accept: () => {
                this.borrarReporte(reporte);
            },
        });
    }

    borrarReporte(reporte: Reporte): void {
        this.administracionService.borrarReporte(reporte.uuid).subscribe(
            async (data) => {
                this.reportes = await this.administracionService.getReportesActivosData();
                this.ui.mostrarMensaje("success", `El reporte ${reporte.name} ha sido eliminado con éxito.`);
            },
            (err) => {
                this.ui.mostrarError(err);
            }
        );
    }

    confirmarBorrarSeleccionados(): void {
        this.ui.limpiarMessages();
        this.confirmationService.confirm({
            message: "¿Está seguro de eliminar los reportes seleccionados?. No será posible recuperar la información.",
            accept: () => {
                this.borrarReportes();
            },
        });
    }

    borrarReportes(): void {
        this.eliminarData = new EliminarData();
        if (this.reportesSeleccionados && this.reportesSeleccionados.length) {
            this.eliminarData.uuids = this.reportesSeleccionados.map(function(obj) {
                return obj['uuid'];
            });
            this.administracionService.borrarReportes(this.eliminarData).subscribe(
                async (data) => {
                    this.reportes = await this.administracionService.getReportesActivosData();
                    this.reportesSeleccionados = [];
                    this.ui.mostrarMensaje("success", `Los reportes seleccionados han sido eliminados con éxito.`);
                },
                (err) => {
                    this.ui.mostrarError(err);
                }
            );
        } else {
            this.ui.mostrarMensaje("warn", `No se han seleccionado reportes para su eliminación.`);
        }
    }

    /**
    ** Métodos de formulario
    **/
    findNodeRecursive(node: TreeNode, tipo: string) {
        if (node['data'] && node['data']['routerLink'] === tipo) {
            this.catalogoModulosArbolSimpleNodoSeleccionado = node;
        } else {
            if (node.children) {
                node.children.forEach((childNode) => {
                    this.findNodeRecursive(childNode, tipo);
                });
            }
        }
    }

    cargarModulos() {
        this.ui.limpiarMessages();
        this.mostrarEditorModulo = true;
    }

    asignarModulo(): void {
        this.ui.limpiarMessages();
        this.mostrarEditorModulo = false;
    }

    mostrarCargaArchivoReporte(event: { preventDefault: () => void; }) {
        this.ui.limpiarMessages();
        if (!this.reporte.id) {
            if (!this.catalogoModulosArbolSimpleNodoSeleccionado) {
                this.ui.mostrarMensaje("error", `${this.appConfig.ux.formIvalid}`);
            } else {
                //Establecer valores UX
                this.reporte.tipo = this.catalogoModulosArbolSimpleNodoSeleccionado['data']['routerLink'];
                this.administracionService.guardarReporte(this.reporte).subscribe(
                    (data) => {
                        this.reporte = data;
                        this.administracionService.getReportesActivos().subscribe(data => {
                            this.reportes = data;
                            event.preventDefault();
                            if (this.fileInput) {
                                this.fileInput.clear();
                            }
                            this.mostrarVentanaCargaArchivos = true;
                        });
                    },
                    (err) => {
                        this.ui.mostrarError(err);
                    }
                );
            }
        } else {
            event.preventDefault();
            if (this.fileInput) {
                this.fileInput.clear();
            }
            this.administracionService.getReporte(this.reporte.uuid).subscribe(data => {
                this.reporte = data;
                this.mostrarVentanaCargaArchivos = true;
            });

        }
    }

    cargarArchivos() {
        this.isSubmitting = false;
        this.cargarArchivosForm.markAllAsTouched();
        if (this.cargarArchivosForm.valid && !this.file_error) {
            this.fileInput.upload(); //Envia la carga de archivo
            this.isSubmitting = true;
            this.messageService.add({ severity: 'success', summary: `Carga de datos exitosa`, detail: `Los datos se registrarón en el servidor. Cierre la ventana.` });
            this.toggleModal(!this.isSubmitting);
        } else {
            this.messageService.add({ severity: 'error', summary: `No se pudo enviar la carga de datos`, detail: `Verífique el nombre del archivo y/o llene toda la información requerida.` });
        }
    }

    onBeforeUpload(event) {
        event.formData.append('entidad', "reporte");
        event.formData.append('uuid', this.reporte.uuid);
        event.formData.append('nombre', this.reporte.name);
        event.formData.append('descripcion', "dummy");
    }

    onUpload(event) {

        this.administracionService.getReportesActivos().subscribe(data => {
            this.reportes = data;
        });
    }

    onArchivoSeleccionado(event) {
        this.file_error = false;
    }

    toggleModal(open: any) {
        this.mostrarVentanaCargaArchivos = open;
    }

    getNombreArchivo(ruta: string): string {
        if (!ruta) return '';
        let folder = ruta.split("/")[0];
        let archivo = ruta.split("/")[1];
        return archivo;
    }

}
